import StdFilter from '@shared/components/filters/std-filter/std-filter';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';

@Component({
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-std-form': StdForm,
  },
})
export default class ExtendedFiltersMixin extends Vue {
  $refs: {
    extendedFilter: InstanceType<typeof StdFilter> & {
      setFilterModel(filterModel): void;
      filterModel: AnyEntity;
    };
    stdCustomFiltersForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
    customFilterSelector: InstanceType<typeof CustomFilterSelector> & {
      getCustomFilters(): Promise<object>;
    };
  };

  showExtendedFilterSection = false;
  disabledExtendedFilterForm = false;
  showExtendedFilterSectionForm = false;
  isSavingCustomFilters = false;
  showCustomFiltersForm = false;
  public customFilterModel: AnyEntity = null;
  declare storeName;
  get filterModel() {
    return this.$store.getters[`${this.storeName}/filterModel`](this.entityName);
  }
  declare entityName;

  modalSaveCustomFilterId = 'modal-save_custom_filter-' + this.$bpcHelper.generateUUIDv4();

  // METHODS

  onExtendedFilterFormClose() {
    this.showExtendedFilterSection = false;
    // Remove extended filters class to body
    document.body.classList.remove('extended-filters-opened');
  }

  // onExtendedFilterFormSearch(model = null) {
  //   const filterModel = model ? model : this.$refs.extendedFilter.filterModel;
  //   console.log('onExtendedFilterFormSearch', filterModel);
  //   // NOTE to be implemented in the component
  // }

  onExtendedFilterFormToggle() {
    this.showExtendedFilterSection = !this.showExtendedFilterSection;
    if (this.showExtendedFilterSection && !this.showExtendedFilterSectionForm) {
      this.showExtendedFilterSectionForm = true;
    }
    if (this.$refs.extendedFilter && this.showExtendedFilterSection) {
      this.$refs.extendedFilter.setFilterModel(this.filterModel);
    }
    // Add or remove extended filters class to body
    if (this.showExtendedFilterSection) {
      document.body.classList.add('extended-filters-opened');
    } else {
      document.body.classList.remove('extended-filters-opened');
    }
  }
  onChangeFilter() {
    // NOTE to be implemented in the component
  }
  refreshExtendedFilterSection() {
    this.showExtendedFilterSectionForm = false;
    if (this.showExtendedFilterSection) {
      setTimeout(() => {
        this.showExtendedFilterSectionForm = true;
      });
    }
  }

  onCustomFilterFormOpen() {
    this.isSavingCustomFilters = false;
    this.showCustomFiltersForm = true;
    this.$bvModal.show(this.modalSaveCustomFilterId);
  }

  onCustomFilterFormClose() {
    this.customFilterModel = null;
    this.$bvModal.hide(this.modalSaveCustomFilterId);
    this.isSavingCustomFilters = false;
    this.showCustomFiltersForm = false;
  }

  async onCustomFilterFormSave(model = null) {
    this.isSavingCustomFilters = true;

    const filterModel = model ? model : this.$refs.extendedFilter.filterModel;
    const customFiltersModel = this.$refs.stdCustomFiltersForm.formModel;
    customFiltersModel.entity = this.entityName;
    customFiltersModel.filters = filterModel;

    this.$set(this.$refs.stdCustomFiltersForm, 'formModel', customFiltersModel);

    await this.$refs.stdCustomFiltersForm.saveEntity();
    await this.$refs.customFilterSelector.getCustomFilters();
    // Save customFilterForm
    // this.isSavingCustomFilters = false;
    // this.showCustomFiltersForm = false;
    this.onCustomFilterFormClose();
  }
}
